import type { RangeFilterColumn, RangeFilterState } from "@/components/keyword-bank/constants";

export const LANDSCAPE_RANGE_FILTER_COLUMNS: RangeFilterColumn[] = [
  { id: "keyword_sales", label: "KW Sales", field: "keyword_sales" },
  { id: "exactVol", label: "Search Volume", field: "exactVol" },
  { id: "kpg", label: "KPS", field: "kpg", minBound: 0, maxBound: 100 },
  { id: "asin_density", label: "ASIN Density", field: "asin_density" },
  { id: "competitors", label: "Competition", field: "competitors" },
  { id: "hero_relevance", label: "Relevance", field: "hero_relevance" },
  { id: "search_volume", label: "Trend", field: "search_volume" },
  { id: "heroRank", label: "Hero Rank", field: "heroRank" },
];

export const DEFAULT_LANDSCAPE_RANGE_FILTERS: RangeFilterState = {
  keyword_sales: { min: null, max: null },
  exactVol: { min: null, max: null },
  kpg: { min: null, max: null },
  asin_density: { min: null, max: null },
  competitors: { min: null, max: null },
  hero_relevance: { min: null, max: null },
  search_volume: { min: null, max: null },
  heroRank: { min: null, max: null },
};

/**
 * AUT-478: the landscape table's only checkbox-style filter.
 *
 * Copy and shape read from the prototype's own column definition
 * (`signal-v3` `origin/signal-v2:src/components/keyword-landscape-output/UnifiedLandscapeTable.tsx`,
 * the `masterList` entry in `keywordFilterColumns`) — label "Master Keyword List", one option
 * reading "Only show keywords on the master list". `design-input/landscape-master-list-filter/`
 * records the reading and the commit it came from.
 *
 * It is a single-option checkbox rather than a toggle because that is what the design uses and
 * because `CombinedFilterDropdown` already renders options this way, chip included — the table
 * previously passed `columns={[]}` and got no checkbox section at all.
 */
export const MASTER_LIST_ONLY = "only";

export const LANDSCAPE_CHECKBOX_FILTER_COLUMNS = [
  {
    id: "masterList",
    label: "Master Keyword List",
    options: [{ value: MASTER_LIST_ONLY, label: "Only show keywords on the master list" }],
    /*
     * Two of the panel's four columns. The option label needs 276px to stay on one line, as it is
     * in the prototype, and one column of the 920px panel is 202px. Spanning two gives 428px --
     * three equal columns would give 277px, one pixel of headroom, which the first font or copy
     * change would eat.
     */
    columnSpan: 2,
  },
];
